<template>
<v-list-item >
  <v-list-item-avatar v-if='space.settings && space.settings.logo_picture' >
    <v-img :src='space.settings.logo_picture' />
  </v-list-item-avatar>
  <v-list-item-content>
    <v-list-item-title >
      {{ space.title }}
      <v-spacer/>
    </v-list-item-title>
    <v-list-item-subtitle v-if='space.settings' >
      {{space.settings.practice_name}} <small v-if='space.settings.practice_number' >{{space.settings.practice_number}}</small>
    </v-list-item-subtitle>
  </v-list-item-content>
  <slot name='list-item-action' >
  </slot>
</v-list-item>
</template>
<script>
export default {
  name: 'SpaceListItem',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    space () { return this.item }
  }
}
</script>
